<footer id="footer">

  <div class="footer-logo">
    <img src="assets/img/logo_praticko_shuttle.png" alt="Praticko" class="img-fluid" style="max-width: 158px;">
  </div>

  <div class="footer-links">
    <span [innerHTML]="'base.footer_text' | translate"></span>
    <span class="footer-sep">·</span>
    <a href="#" title="Chi siamo" class="footer-link">{{ 'menu_privacy_cookie' | translate }}</a>
  </div>

  <div class="footer-copy">
    &copy; {{ settings.getAppSetting('year') }} {{ settings.getAppSetting('name') }} &nbsp;·&nbsp; v{{
    settings.getAppSetting('version') }}
  </div>

</footer>